import React, { useEffect, useState } from "react";
import "../../../assets/AdminCss/dashboard.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import ToastMessage from "../../ToastMessage";
const base_url= process.env.REACT_APP_API_URL;


const AdminSettings = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [formData, setFormData] = useState({
    rate: "",
    walletOwnerName: "",
    upiId: "",
    upiId2: "",
    upiId3: "",
    upiId4: "",
    usdtWalletAddrs: "",
    qr_code_image: null,
    holderName: "",
    bankName: "",
    acctNumber: "",
    IFSCcode: "",
    holderName2: "",
    bankName2: "",
    acctNumber2: "",
    IFSCcode2: "",
    holderName3: "",
    bankName3: "",
    acctNumber3: "",
    IFSCcode3: "",
    holderName4: "",
    bankName4: "",
    acctNumber4: "",
    IFSCcode4: "",
  });

  const auth=  localStorage.getItem('admin');

  const [form2, setForm2]= useState({
    telelink:'',
    teleservice:'',
    applink:'',
    whatsappnumber:''
  });
  const [loading, setLoading] = useState(false); // For loading state
  const [error, setError] = useState(""); // For error messages

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: Check if all fields except qr_code_image are filled
    const requiredFields = [
      "rate",
      "walletOwnerName",
      "upiId",
      "usdtWalletAddrs",
      "holderName",
      "bankName",
      "acctNumber",
      "IFSCcode",
     
    ];

    const missingFields = requiredFields.filter((field) => !formData[field]);
    if (missingFields.length > 0) {
      ToastMessage(
        0,
        `Please fill all required fields: ${missingFields.join(", ")}`
      );
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("name_bank", formData.rate);
    formDataToSend.append("name_user", formData.walletOwnerName);
    formDataToSend.append("stk", formData.upiId);
    formDataToSend.append("stk2", formData.upiId2);
    formDataToSend.append("stk3", formData.upiId3);
    formDataToSend.append("stk4", formData.upiId4);
    formDataToSend.append("usdt_wallet_address", formData.usdtWalletAddrs);
    formDataToSend.append("holder_name", formData.holderName);
    formDataToSend.append("bank_name", formData.bankName);
    formDataToSend.append("account_number", formData.acctNumber);
    formDataToSend.append("ifsc", formData.IFSCcode);
    formDataToSend.append("holder_name2", formData.holderName2);
    formDataToSend.append("bank_name2", formData.bankName2);
    formDataToSend.append("account_number2", formData.acctNumber2);
    formDataToSend.append("ifsc2", formData.IFSCcode2);
    formDataToSend.append("holder_name3", formData.holderName3);
    formDataToSend.append("bank_name3", formData.bankName3);
    formDataToSend.append("account_number3", formData.acctNumber3);
    formDataToSend.append("ifsc3", formData.IFSCcode3);
    formDataToSend.append("holder_name4", formData.holderName4);
    formDataToSend.append("bank_name4", formData.bankName4);
    formDataToSend.append("account_number4", formData.acctNumber4);
    formDataToSend.append("ifsc4", formData.IFSCcode4);
    formDataToSend.append("typer", "momo");

    if (formData.qr_code_image) {
      formDataToSend.append("qr_code_image", formData.qr_code_image);
    }

    setLoading(true);
    try {
      if (formData.qr_code_image instanceof File) {

        const response = await axios.post(
          `${base_url}/admin/manager/settings/bank`,
          formDataToSend,
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
              Authorization: `${auth}`,
            },
          }
        );
        // console.log(response, "Post bank response");
        ToastMessage(1, response.data.message);
      } else {
        ToastMessage(0, "All Field are required");
      }
    } catch (error) {
      setError(error.message || "An error occurred");
      ToastMessage(0, "An error occurred");
      console.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit2= async(e)=> {
    e.preventDefault();

    // console.log('form',form2);

    setLoading(true);
    try{
      await axios.post(base_url+'/admin/webapi/post/telegram',
        form2,
        {
          withCredentials:true,
          headers:{
            'content-type':'application/json',
            Authorization:`${auth},`
          }
        }
      )

      ToastMessage(1,'Data updated successfully');

    }catch(err){
      ToastMessage(0,'Failed to store telegram data')
    }
  }

  const handleChange2= (e)=> {
    const {name, value}= e.target;
    setForm2((prevData)=> ({
      ...prevData,
      [name]: value,
    }));
  };



  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };



  useEffect(() => {

    window.scrollTo(0,0);

    const fetchTelegram= async()=> {

      try{

        const response= await axios.get(base_url + '/admin/webapi/get/telegramData',
          {
            headers:{
              'content-type':'application/json',
              Authorization:`${auth}`,
            }
          }
        )
        // console.log('respp',response);

        if(response?.data.success){
          const data= response?.data.result[0];
          // console.log('dd',data[0]);

          setForm2({
            telelink:data.telelink,
            teleservice:data.teleservice,
            applink:data.applink,
            whatsappnumber:data.whatsappnumber,
          });
        };

      }catch(err){
        ToastMessage(0,'Failed to fetch telegram data');
      }
    };

    fetchTelegram();
    const fetchBankDetails = async () => {
      setLoading(true);
      try {

        const res = await axios.get(base_url + "/admin/manager/settings/get", {
          headers: {
            Accept: "application/json",
            Authorization:`${auth}`,
          },
        });
        console.log("Response data os bank" , res);
        if(res.data.status){
          setFormData({
            rate: res.data.momo.name_bank,
            walletOwnerName: res.data.momo.username,
            upiId: res.data.momo.upi_id,
            upiId2: res.data.momo.upi_id2,
            upiId3: res.data.momo.upi_id3,
            upiId4: res.data.momo.upi_id4,
            usdtWalletAddrs: res.data.momo.usdt_wallet_address,
            holderName: res.data.momo.holder_name,
            bankName: res.data.momo.bank_name,
            QR: res.data.momo.qr_code_image,
            acctNumber: res.data.momo.account_number,
            IFSCcode: res.data.momo.ifsc_code,
            holderName2: res.data.momo.holder_name2,
            bankName2: res.data.momo.bank_name2,
            acctNumber2: res.data.momo.account_number2,
            IFSCcode2: res.data.momo.ifsc_code2,
            holderName3: res.data.momo.holder_name3,
            bankName3: res.data.momo.bank_name3,
            acctNumber3: res.data.momo.account_number3,
            IFSCcode3: res.data.momo.ifsc_code3,
            holderName4: res.data.momo.holder_name4,
            bankName4: res.data.momo.bank_name4,
            acctNumber4: res.data.momo.account_number4,
            IFSCcode4: res.data.momo.ifsc_code4,
          });
        }
        
      } catch (error) {
        setError("Failed to fetch bank details");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchBankDetails();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  

  return (
    <div className="wrapper">
      {/* Main Sidebar */}
      <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Settings</h1>
              </div>
            </div>
          </div>
        </section>

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div style={{ padding: "10px 20px", marginBottom: "200px" }}>
                <div className="form-group setting">
                  <div className="text-center">
                    <label htmlFor="quantity">Manual Settings</label>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <label
                      htmlFor="edit-momo-name_bank"
                      style={{ color: "#3498db" }}
                    >
                      Rate
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Rate"
                      onChange={handleChange}
                      name="rate"
                      id="edit-momo-name_bank"
                      value={formData.rate}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Wallet Owner Name"
                      name="walletOwnerName"
                      onChange={handleChange}
                      id="edit-momo-name"
                      value={formData.walletOwnerName}
                    />
                    <br />
                    <h6>UPI 1 Rs(300 - 999)</h6>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="UPI ID 1"
                      id="edit-momo-info"
                      name="upiId"
                      onChange={handleChange}
                      value={formData.upiId}
                    />
                      <br />
                      <h6>UPI 2    Rs(1000 - 2999)</h6>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="UPI ID 2"
                      id="edit-momo-info"
                      name="upiId2"
                      onChange={handleChange}
                      value={formData.upiId2}
                    />
                      <br />
                      <h6>UPI 3  Rs(3000 - 4999)</h6>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="UPI ID 3"
                      id="edit-momo-info"
                      name="upiId3"
                      onChange={handleChange}
                      value={formData.upiId3}
                    />
                      <br />
                      <h6>UPI 4    Rs(5000 - above)</h6>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="UPI ID 4"
                      id="edit-momo-info"
                      name="upiId4"
                      onChange={handleChange}
                      value={formData.upiId4}
                    />
                    <br />
                    <h6>USDT Wallet Address</h6>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="USDT Wallet Address"
                      name="usdtWalletAddrs"
                      onChange={handleChange}
                      id="edit-momo-qr"
                      value={formData.usdtWalletAddrs}
                    />
                    <br />
                    <h6>Qr </h6>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleFileChange}
                      placeholder="qr_code_image"
                      id="edit-momo-scanner"
                      name="qr_code_image"
                      
                     

                    />
                    <br />
                    <h6>Bank 1    Rs( 300 - 999)</h6>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Holder Name"
                      name="holderName"
                      onChange={handleChange}
                      id="edit-momo-holdername"
                      value={formData.holderName}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Bank Name"
                      name="bankName"
                      onChange={handleChange}
                      id="edit-momo-bankname"
                      value={formData.bankName}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Account Number"
                      name="acctNumber"
                      onChange={handleChange}
                      id="edit-momo-acnumber"
                      value={formData.acctNumber}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="IFSC Code"
                      id="edit-momo-ifsc"
                      name="IFSCcode"
                      onChange={handleChange}
                      value={formData.IFSCcode}
                    />
                    <br />
                    <h6>Bank 2     Rs( 1000 - 1999)</h6>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Holder Name"
                      name="holderName2"
                      onChange={handleChange}
                      id="edit-momo-holdername2"
                      value={formData.holderName2}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Bank Name"
                      name="bankName2"
                      onChange={handleChange}
                      id="edit-momo-bankname2"
                      value={formData.bankName2}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Account Number"
                      name="acctNumber2"
                      onChange={handleChange}
                      id="edit-momo-acnumber2"
                      value={formData.acctNumber2}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="IFSC Code"
                      id="edit-momo-ifsc2"
                      name="IFSCcode2"
                      onChange={handleChange}
                      value={formData.IFSCcode2}
                    />
                    <h6>Bank 3      Rs( 2000 - 4999)</h6>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Holder Name"
                      name="holderName3"
                      onChange={handleChange}
                      id="edit-momo-holdername3"
                      value={formData.holderName3}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Bank Name"
                      name="bankName3"
                      onChange={handleChange}
                      id="edit-momo-bankname3"
                      value={formData.bankName3}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Account Number"
                      name="acctNumber3"
                      onChange={handleChange}
                      id="edit-momo-acnumber3"
                      value={formData.acctNumber3}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="IFSC Code"
                      id="edit-momo-ifsc3"
                      name="IFSCcode3"
                      onChange={handleChange}
                      value={formData.IFSCcode3}
                    />
                    <h6>Bank 4    Rs( 5000 - above)</h6>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Holder Name"
                      name="holderName4"
                      onChange={handleChange}
                      id="edit-momo-holdername4"
                      value={formData.holderName4}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Bank Name"
                      name="bankName4"
                      onChange={handleChange}
                      id="edit-momo-bankname4"
                      value={formData.bankName4}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Account Number"
                      name="acctNumber4"
                      onChange={handleChange}
                      id="edit-momo-acnumber4"
                      value={formData.acctNumber4}
                    />
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="IFSC Code"
                      id="edit-momo-ifsc4"
                      name="IFSCcode4"
                      onChange={handleChange}
                      value={formData.IFSCcode4}
                    />
                    <br />
                    <button
                      type="submit"
                      className='btn btn-primary edit-momo'
                      style={{ width: "100%" }}
                    >
                      Submit
                    </button>
                  </form>
                </div>

                <div className="form-group setting">
                  <div className="text-center">
                    <label htmlFor="telegram">Telegram</label>
                  </div>
                  
                  <form onSubmit={handleSubmit2}>
                  <label htmlFor="telegram" style={{ color: "#3498db" }}>
                    Telegram
                  </label>
                  <input
                    type="text"
                    name="telelink"
                    className="form-control"
                    id="telegram"
                    placeholder="Enter Telegram Link"
                    onChange={handleChange2}
                    value={form2.telelink}
                  />
                  <br />
                  <label htmlFor="cskh" style={{ color: "#3498db" }}>
                    Online Services
                  </label>
                  <input
                    type="text"
                    name="teleservice"
                    className="form-control"
                    id="cskh"
                    placeholder="Online Services"
                    onChange={handleChange2}
                    value={form2.teleservice}
                  />
                  <br />
                  <label htmlFor="myapp_web" style={{ color: "#3498db" }}>
                    App Download Link
                  </label>
                  <input
                    type="text"
                    name="applink"
                    className="form-control"
                    id="myapp_web"
                    placeholder="Enter App Link"
                    onChange={handleChange2}
                    value={form2.applink}
                  />
                  <br />

                  <label htmlFor="myapp_web" style={{ color: "#3498db" }}>
                    Whastapp
                  </label>
                  <input
                    type="text"
                    name="whatsappnumber"
                    className="form-control"
                    id="myapp_web"
                    placeholder="Enter whatsapp Number"
                    onChange={handleChange2}
                    value={form2.whatsappnumber}
                  />
                  <br />
                  <button
                    type="submit"
                    className="btn btn-primary telegram"
                    style={{ width: "100%" }}
                  >
                    Submit
                  </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
